module.exports = __webpack_public_path__ + "img/03_Conflict Confronter.f52ae20e.svg";